module.exports = "/_next/static/images/b4914ac0d37f191c579cbec57deed299-nobureaucracy@1x.png";